import CarouselDots from './CarouselDots';

export default CarouselDots;
